import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from './pages/not-found/not-found.component';
import { VideoWatchPageComponent } from './pages/video-watch-page/video-watch-page.component';
import { AnalysisComponent } from './pages/analysis/analysis.component';
import { PerformanceComponent } from './pages/performance/performance.component';
import { HealthComponent } from './pages/health/health.component';
import { UploadVideoComponent } from './pages/upload-video/upload-video.component';
import { LoginPageComponent } from './features/sso-wise-id/view/login-page/login-page.component';
import { AfterLoginComponent } from './features/sso-wise-id/view/after-login/after-login.component';
import { WiseIdAuthGuard } from './features/sso-wise-id/controller/wise-id-auth.guard';
import { LogoutComponent } from './features/sso-wise-id/view/logout/logout.component';
import { ProfileComponent } from './pages/profile/profile.component';

/**
 * Se define las rutas de la aplicación, los componentes que se muestran en dichas
 * rutas y en caso de necesitar alguna condición para acceder, el Guard correspondiente.
 */
const routes: Routes = [
  { path: '', redirectTo: '/analysis', pathMatch: 'full' }, // Default route
  { path: 'home', redirectTo: '/analysis', pathMatch: 'full' },
  { path: 'login', component: LoginPageComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'profile', component: ProfileComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'after-login', component: AfterLoginComponent },
  { path: 'analysis', component: AnalysisComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'performance', component: PerformanceComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'health', component: HealthComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'upload', component: UploadVideoComponent, canActivate: [WiseIdAuthGuard] },
  { path: 'watch/:id', component: VideoWatchPageComponent, canActivate: [WiseIdAuthGuard] },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
